import Steps from "./Steps";
import Step from "./Step";
import "./index.scss";

const StepsClone: typeof Steps & {
  Step: typeof Step;
} = Object.assign(Steps, { Step });

export default StepsClone;
